// Tesla paint codes -> friendly display name + closest hex.
// Friendly name shown in UI; hex used for color dot/border.
export const TESLA_COLORS = [
  { code: "PPSW", name: "Pearl White Multi-Coat", hex: "#F4F4F4" },
  { code: "PBCW", name: "Ceramic White", hex: "#EDEDED" },
  { code: "PN00", name: "Quicksilver", hex: "#C5C7C8" },
  { code: "PPSV", name: "Silver Metallic", hex: "#ABABAB" },
  { code: "MS01", name: "Mercury Silver", hex: "#989B9F" },
  { code: "PMTG", name: "Titanium Metallic", hex: "#6E6F71" },
  { code: "PN01", name: "Stealth Grey", hex: "#5A5A5C" },
  { code: "PMNG", name: "Midnight Silver Metallic", hex: "#3D3D3F" },
  { code: "PBT85", name: "Obsidian Black Metallic", hex: "#1B1B1D" },
  { code: "PX02", name: "Diamond Black", hex: "#15151A" },
  { code: "PBSB", name: "Solid Black", hex: "#0A0A0A" },
  { code: "PB01", name: "Glacier Blue", hex: "#6FA8C9" },
  { code: "PPSB", name: "Deep Blue Metallic", hex: "#1F3A5F" },
  { code: "PR01", name: "Ultra Red", hex: "#C8102E" },
  { code: "PR00", name: "Red Multi-Coat", hex: "#B8002C" },
  { code: "PPSR", name: "Signature Red", hex: "#A30E1A" },
  { code: "MCR01", name: "Midnight Cherry Red", hex: "#4D0F1A" },
];

export const findColorByName = (name) =>
  TESLA_COLORS.find((c) => c.name === name) || null;

export const findColorByHex = (hex) =>
  TESLA_COLORS.find((c) => c.hex.toLowerCase() === (hex || "").toLowerCase()) ||
  null;
